'use strict';

let zoomInstances = [];

/**
 * Creates a single xzoom instance
 */
function instanceZoom() {
    try {
        $('.carousel-item.active .xzoom, .carousel-item.active .xzoom-gallery').xzoom({ Xoffset: 15});
    }
    catch (error) {
        console.error(error);
    }
}

/**
 * First load
 */
function initZoom() {
    instanceZoom();
    zoomInstances[0] = true;
}

/**
 * Creates xzoom instances when a new slide is shown in the carousel
 */
function handleCarouselSlide(event) {
    const index = $(event.relatedTarget).index()

    if(!zoomInstances[index]) {
        instanceZoom();
        zoomInstances[index] = true;
    }
}

/**
 * Switch classes to keep active element
 */
function handleProductThumbnailClick() {
    //Clears all thumbnails active class
    $('.product-thumbnails .product-thumbnail').removeClass('active');
    //Turns active clicked thumbnail
    $(this).addClass('active');
}

/**
 * Listener for product thumbnails images click
 */
function initImageEvents() {
    $('.product-thumbnails .product-thumbnail').on('click', handleProductThumbnailClick);
    $('.carousel.slide').on('slid.bs.carousel', handleCarouselSlide);
}


module.exports = {
    initZoom,
    initImageEvents
}